/* eslint-disable max-len */
import { SplitIcon, WarningWithTooltip, OriginalCurrencyComponent } from './sharedComponents';

export const metalsQuotes = {
  columnParams: 'grid-cols-[1fr,1fr,1fr,1fr] sm:grid-cols-[1fr,1fr,1fr,minmax(0,1fr),minmax(0,1fr),minmax(0,1fr),3fr]',
  columns: [
    [{ id: 'assetName', type: 'string', textAlign: 'text-left', usesHeader: 'assetId' }],
    [
      { id: 'date', type: 'date', textAlign: 'text-left' },
      { id: 'source', type: 'string', classNamesBoth: 'sm:hidden' },
    ],
    [{ id: 'source', type: 'string', classNamesBoth: 'hidden sm:block', textAlign: 'text-center' }],
    [{ id: 'quoteBaseCurrency', usesHeader: 'price', type: 'currency0Decimals' }], // usesHeader: if found, the header and tooltip will use this element from the i18n file
    [{ id: 'currency', type: 'string', classNamesBoth: 'hidden sm:block' }],
    [
      { id: 'quote', usesHeader: 'originalPrice', type: 'number0Decimals' },
      { id: 'currency', type: 'string', classNamesBoth: 'sm:hidden' },
    ],
    [{ id: 'note', type: 'string', classNamesBoth: 'hidden sm:block' }],
  ],
};

export const metalsTransactions = {
  columnParams: 'grid-cols-[5rem,1fr,1fr,1fr,3rem] xs:grid-cols-[1fr,1fr,1fr,1fr,1fr,1fr,3rem]',
  columns: [
    [
      // prettier-ignore
      {
        ifSummaryRowDisplay: false, id: 'date', type: 'date', textAlign: 'text-left', classNamesBoth: 'text-xs sm:text-sm flex gap-1 items-align', displayElement: { field: 'itemHasFlag', element: WarningWithTooltip },
        // ^^ need this for both columns
      },
      // prettier-ignore
      {
        ifSummaryRowDisplay: false, id: 'openPositionSize', type: 'number0Decimals', classNamesBody: 'text-xs text-gray-400 font-normal', classNamesBoth: 'xs:hidden', hideHeaderLabel: true,
      },
      // prettier-ignore
      {
        ifSummaryRowDisplay: true, id: 'assetName', type: 'string', textAlign: 'text-left', classNamesBoth: 'text-xs sm:text-sm', ifSummaryRowClassNames: 'text-brandBlue-600 truncate', usesHeader: 'displayName',
      },
      // prettier-ignore
      {
        ifSummaryRowDisplay: true, id: 'openPositionSize', type: 'number0Decimals', classNamesBody: 'text-xs text-gray-400 font-normal', classNamesBoth: 'xs:hidden', hideHeaderLabel: true,
      },
    ],
    [
      // prettier-ignore
      {
        id: 'openPositionSize', type: 'number0Decimals', classNamesBody: 'text-xs sm:text-sm', classNamesBoth: 'hidden xs:block', displayElement: { field: 'isPreSplitTransaction', element: SplitIcon },
      },
      { id: 'currentValue', usesHeader: 'currentValue', type: 'currency', classNamesBody: 'text-xs sm:text-sm', classNamesBoth: 'xs:hidden' },
      { id: 'purchaseValue', usesHeader: 'purchaseValueFull', type: 'currency', classNamesBody: 'text-xs sm:text-sm', classNamesBoth: 'xs:hidden' },
    ],
    [
      { id: 'purchaseValue', usesHeader: 'purchaseValueFull', type: 'currency', classNamesBody: 'text-xs sm:text-sm', classNamesBoth: 'hidden xs:block' },
      {
        id: 'purchaseQuote',
        type: 'currency',
        classNamesBody: 'text-xs text-gray-400',
        classNamesBoth: 'hidden xs:block',
        displayElement: { field: 'displayPriceTransactionCurrency', element: OriginalCurrencyComponent },
      },
    ],
    [
      { id: 'currentValue', usesHeader: 'currentValue', type: 'currency', classNamesBody: 'text-xs sm:text-sm', classNamesBoth: 'hidden xs:block' },
      {
        id: 'currentQuote',
        usesHeader: 'currentPrice',
        type: 'currency',
        classNamesBody: 'text-xs text-gray-400',
        classNamesBoth: 'hidden xs:block',
        displayElement: { field: 'displayQuoteTransactionCurrency', element: OriginalCurrencyComponent },
      },
      { id: 'fees', type: 'currency', usesHeader: 'feesSincePurchase', hideHeaderLabel: false, classNamesBody: 'text-xs sm:text-sm', classNamesBoth: 'xs:hidden' },
    ],
    [{ id: 'fees', type: 'currency', hideHeaderLabel: true, classNamesBody: 'text-xs sm:text-sm', classNamesBoth: 'hidden xs:block' }],
    [
      { id: 'roi', type: 'percentage', usesHeader: 'roiOnly', classNamesBody: 'text-xs sm:text-sm', classNamesBoth: 'hidden xs:block' },
      { id: 'roiAnnual', type: 'percentage', classNamesBody: 'text-xs text-gray-400', classNamesBoth: 'hidden xs:block' },
    ],
    [
      // prettier-ignore
      {
        ifSummaryRowDisplay: false, id: 'ellipsis', type: 'ellipsis', usesHeader: 'emptyString', classNamesBody: '-ml-3',
      },
      // prettier-ignore
      {
        ifSummaryRowDisplay: true, id: 'bn', type: 'number0Decimals', hideHeaderLabel: true, displayElement: { field: 'itemHasFlag', element: WarningWithTooltip },
      },
    ],
  ],
};
